angular.module('unica_grand_prix.grand_prix_controllers')

.controller('GrandPrixListZmController',
	function(
		$rootScope, $scope, $state, $stateParams,
		GrandPrixRankingListService
	) {


	$scope.loadRankings = function() {
		$scope.showLoader();

		GrandPrixRankingListService
			.listZm( $rootScope.currentUser.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.rankings = data;
				}
			});
	};

	$scope.loadRankings();

});
